<template>
  <div class="row">
    <div class="col-md-12">
      <p class="clearfix"></p>
      <discount-campaign-form :route="route"></discount-campaign-form>
    </div>
  </div>
</template>
<script>
import DiscountCampaignForm from './DiscountCampaignForm.vue'

export default {
  components: {
    DiscountCampaignForm
  },
  props: {
    route: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/DiscountCampaigns/DiscountCampaignAdd.vue